import { APP_BASE_URL } from "@/shared/constants/appBaseUrl";

export const documentLinks = {
  termsOfService: `${APP_BASE_URL}/docs/terms-of-service.pdf`,
  amlCftPolicy: `${APP_BASE_URL}/docs/aml-cft-policy.pdf`,
  cookiePolicy: `${APP_BASE_URL}/docs/cookie-policy.pdf`,
  riskNotice: `${APP_BASE_URL}/docs/risk-disclosure.pdf`,
  privacyPolicy: `${APP_BASE_URL}/docs/privacy-policy.pdf`,
  intelionAgreement: `${APP_BASE_URL}/docs/intelion-agreement.pdf`
} as const;
